import { render } from "./produdectFilters.vue?vue&type=template&id=e4a17648"
import script from "./produdectFilters.vue?vue&type=script&lang=js"
export * from "./produdectFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__